import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class DocumentTemplateListDataService extends DataService<typeof Model.General.Logic.ViewModels.DocumentTemplateSummary, Model.General.Logic.ViewModels.DocumentTemplateSummary, IDocumentTemplateSummary> {
	protected map(entity: Model.General.Logic.ViewModels.DocumentTemplateSummary): IDocumentTemplateSummary {
		return new DocumentTemplateSummaryModel(entity);
	}

	public static make(context?: ContextService): DocumentTemplateListDataService {
		return new DocumentTemplateListDataService(context, ctx => ctx.DocumentTemplateSummaries);
	}
}

export class DocumentTemplateSummaryModel extends EntityModel<Model.General.Logic.ViewModels.DocumentTemplateSummary, IDocumentTemplateSummary> implements IDocumentTemplateSummary {
	@property<DocumentTemplateSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<DocumentTemplateSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<DocumentTemplateSummaryModel>(o => o.entity.reactComponent, (o, value) => o.entity.reactComponent = value)
	public reactComponent: string;

	@property<DocumentTemplateSummaryModel>(o => o.entity.fileName, (o, value) => o.entity.fileName = value)
	public fileName: string;

	@property<DocumentTemplateSummaryModel>(o => o.entity.isDocument, (o, value) => o.entity.isDocument = value)
	public isDocument: boolean;

	@property<DocumentTemplateSummaryModel>(o => o.entity.documentService, (o, value) => o.entity.documentService = value)
	public documentService: string;

	@property<DocumentTemplateSummaryModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId: number;

	@property<DocumentTemplateSummaryModel>(o => o.entity.categoryDisplayName, (o, value) => o.entity.categoryDisplayName = value)
	public categoryDisplayName: string;

	@property<DocumentTemplateSummaryModel>(o => o.entity.categoryUsages, (o, value) => o.entity.categoryUsages = value)
	public categoryUsages: string;

	@property<DocumentTemplateSummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
	public hasChildren: boolean;
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/list/document-template-list.data.ts